(function () {
 'use strict';

  angular.module('eclipseApp.core').filter('ordinal', function() {
    return function(input) {
      var day = input.match(/([0-9]{1,2})[,]? [0-9]{4}/)[1];
      var day = parseInt(day, 10);
      console.log('day .......', day)


      // Only process numeric values.
      if (isNaN(day) || day === null) return input;

      var s=['th','st','nd','rd'];
      var v=day%100;
      var newDay = day+(s[(v-20)%10]||s[v]||s[0]);

      console.log('newDay', newDay);
      return input.replace(day, newDay);
    };

  });
})();
